import { Button, EarlyAccessBanner, theme } from '@lmc/ui-kit'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'

const ROTA_PRODUCT_BOARD_URL =
  'https://portal.productboard.com/ambpva5y3bxf5myjgnmwwnpg/c/65-rostering-beta-feedback'

type RotaBannerProps = {
  enabled?: boolean
  fullWidth?: boolean
}

export const RotaBanner: FC<RotaBannerProps> = ({
  enabled = true,
  fullWidth = false
}) => {
  const { t } = useTranslation()

  if (!enabled) {
    return null
  }

  return (
    <BannerWrapper fullWidth={fullWidth}>
      <EarlyAccessBanner
        title={t('ROTA_EARLY_ACCESS_TITLE')}
        description={t('ROTA_EARLY_ACCESS_DESCRIPTION')}
        color={theme.color.category.foodAndDrink}
        cta={
          <a href={ROTA_PRODUCT_BOARD_URL} rel="noreferrer" target="_blank">
            <Button variant="default">
              {t('ROTA_EARLY_ACCESS_BUTTON_TEXT')}
            </Button>
          </a>
        }
      />
    </BannerWrapper>
  )
}

const BannerWrapper = styled.div<{ fullWidth?: boolean }>`
  max-width: ${(props) => (props.fullWidth ? 'unset' : `1080px`)};
  margin-left: ${(props) => (props.fullWidth ? 'unset' : `auto`)};
  margin-right: ${(props) => (props.fullWidth ? 'unset' : `auto`)};
`
